export default __webpack_public_path__ + "images/OZ.42efc33.png";